import { axios } from '@/services/axios';

export const deleteRegistrar = (registrarId, requiredScope) => {
    const endpoint = `/TRSRegistrar/${registrarId}`;
    const res = axios.delete(endpoint, {
        headers: {
            'X-RequestScope': requiredScope,
        },
    });
    return res;
};
